<template lang="html">
    <div>
        <div v-for="product in products" class="mb-2">
            <div class="productRow d-flex align-items-center pointer" :class="{'selected':isThisProductSelected(product)}" @click="blacklistProduct(product)">
                <div class="square mr-2" :style="{'background-color':selectProductColor(product).areaBackground, 'border-color':selectProductColor(product).areaBorder}"></div>
                <div>{{product.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
    beforeMount: function () {
        this.selectCorrectProducts()
    },
    mounted: function () {
        this.$emit('loaded')
    },
    props:{
        products: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            // blacklistProducts: []
        }
    },
    computed: {
        ...mapGetters([
            'getEventColors',
            'getfilterBlacklistProducts'
        ]),
        blacklistProducts: {
            get: function () {
                return this.getfilterBlacklistProducts
            },
            set: function(newVal) {
                this.changefilterBlacklistProducts(newVal)
            }
        }
    },
    methods:{
        ...mapActions([
            'changefilterBlacklistProducts'
        ]),
        blacklistProduct: function(product) {
            let thisProdId = product.id
            let clickedProduct = this.blacklistProducts.find(blacklistedProduct => blacklistedProduct.id == thisProdId)


            if(clickedProduct == undefined){
                this.blacklistProducts.push(product)
            } else {
                this.blacklistProducts.splice(this.blacklistProducts.indexOf(clickedProduct), 1)
            }

            this.sectionChanged()
        },
        isThisProductSelected: function (product) {
            return this.blacklistProducts.find(selectedProduct => selectedProduct.id == product.id) == undefined
        },
        sectionChanged: function () {
            this.$emit('change', this.blacklistProducts)
        },
        selectProductColor: function (product) {
            let productColorSelected = this.getEventColors.find(color => {return color.id == product.color})

            if(this.isThisProductSelected(product)){
                return {
                    areaBackground: productColorSelected.code,
                    areaBorder: productColorSelected.codeSecundary,
                }
            } else {
                return {
                    areaBackground: '#FFF',
                    areaBorder: null,
                }
            }
        },
        selectAll: function () {
            for (var i = 0; i < this.products.length; i++) {
                this.$set(this.blacklistProducts, i, this.products[i])
            }
            this.sectionChanged()
        },
        deselectAll: function () {
            this.changefilterBlacklistProducts([])
            this.sectionChanged()
        },
        selectCorrectProducts: function () {
            // this.selectAll()
            if(this.areAllProductsBlackListed()){
                console.log('Warning - areAllProductsBlackListed');
                this.deselectAll()
            } else {
                console.log('not all are blaclisted');

            }
        },
        areAllProductsBlackListed: function () {
            return this.products.filter(product => {
                return this.getfilterBlacklistProducts.find(blacklistedProduct => blacklistedProduct.id == product.id) == undefined;
            }).length == 0
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.productRow{
    opacity: 0.5;
    &.selected{
        opacity: 1;
    }
}
.square{
    width: 20px;
    height: 20px;
    border-radius: 3px;
    background-color: #FFF;
    border-color: $gray-dark;
    border-width: 1px;
    border-style: solid;

}
</style>



// WEBPACK FOOTER //
// productFilterV2.vue?eda7e984